import Hero from "../components/Hero";
import AnimaEquipo from "../components/AnimaEquipo";
import Especialidades from "../components/Especialidades";
import QuienesSomos from "../components/QuienesSomos";
import CentroInstalaciones from "../components/CentroInstalaciones";
import Banner01 from "../components/Banner01";
import Esport from "../pages/Esport";
import Salut from "../pages/Salut";
import AnimaGlobalen2 from "../components/AnimaGlobalen2";
import styles from "../styles/home.module.css";
import { Link } from "react-router-dom";


function Home() {
    return (
        <main>
            
            <Hero subtitle="Pilates, Biomecánica, Nutición, Entrenamientos, Osteopatia, Postural" />

            <div className={styles.divVideo}>
                <video
                    src="assets/videoPortada.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline // Para móviles
                    style={{
                        width: '100%',
                        height: '55vh',
                        objectFit: 'cover'
                    }}
                >
                    Tu navegador no soporta el elemento video.
                </video>
            </div>

            <AnimaGlobalen2 />
            <Especialidades></Especialidades>

        

            <div className={styles.divSeparador}>

              {/*   <Esport></Esport>

                <Salut></Salut> */}


            </div>


            <div className={styles.divInformacion}>
                <div className={styles.botonWrapper}>
                    <Link to="/Precios" className={styles.botonCTADeporte}>
                        <span className={styles.texto}>
                            <span className={styles.icono}>+</span>
                        Precios
                        </span>
                    </Link>
                </div>


                <div className={styles.contletrasGLobalAni01}>
                    <img src="assets/letrasGLOBLAL.png" alt="Letras GLOBAL" className={styles.imagenletrasGlobal} />
                </div>
            </div>


            <div>
                <video className={styles.divVideo}
                    src="assets/video02.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                >
                    Tu navegador no soporta el elemento video.
                </video>
            </div>




            <CentroInstalaciones></CentroInstalaciones>


            <Banner01
                titulo="Reserva tu sesión ahora"
                descripcion="Agenda tu cita fácil y rápido con nuestro equipo profesional."
                linkTo="/contacto"
                linkTexto="RESERVAR CITA"
            />


            <QuienesSomos
                imagen="assets/foto01.jpg"
                titulo1="QUIENES"
                titulo2="SOMOS?"
                descripcion={
                    <>
                        Somos un centro de fisioterapia úbicado en Santa Perpètua de Mogoda
                        con más de 20 años de trayectoria profesional.
                        <br />
                        <br />
                        Contamos con un equipo multidisciplinar altamente cualificado, lo que
                        nos permite abordar de forma integral diferentes patologías y
                        perfiles de pacientes.
                        <br></br> <br></br> ¿Por qué elegirnos?
                    </>
                }
                lista={[
                    "Atención 100% personalizada",
                    "Disponibilidad para urgencias",
                    "Club exclusivo para clientes",
                    "Tratamientos avanzados y premium",
                    "Resultados garantizados",
                    "Financiación flexible y sin intereses",
                ]}
            />

           
            <AnimaEquipo></AnimaEquipo>

        </main>
    );
}

export default Home;
